module.exports = __webpack_public_path__ + "img/games-17.ee31bc2d.jpg";